import React from "react";
import { COLORS } from "./tokens";

/**
 * TREE ICON — simplified Main Logo for embroidery.
 * Just the tree (canopy + trunk + roots) with an optional path flowing forward.
 * Solid single color. No gradients, no sun, no circle background.
 * Perfect for embroidery, POD, tags, chest prints, wall art.
 *
 * Props:
 *  - withPath: include the flowing forward path (default true). Set false for TINY sizes.
 *  - color: single color for the whole design (default sage). Try COLORS.gold too.
 */
const TreeIcon = React.forwardRef(function TreeIcon(
  { size = 240, color = COLORS.sage, pathColor = null, withPath = true, id = "tree-icon" },
  ref
) {
  const actualPathColor = pathColor || color;
  return (
    <svg
      ref={ref}
      id={id}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      width={size}
      height={size}
      role="img"
      aria-label="Rona Wellness — Tree Icon"
    >
      {/* Tree canopy — solid organic cluster */}
      <path
        d="M200 60
           C 143 62, 100 96, 94 142
           C 60 152, 43 190, 62 224
           C 43 252, 62 292, 108 292
           C 130 308, 168 310, 200 300
           C 232 310, 270 308, 292 292
           C 338 292, 357 252, 338 224
           C 357 190, 340 152, 306 142
           C 300 96, 257 62, 200 60 Z"
        fill={color}
      />

      {/* Trunk — clean and thick for embroidery */}
      <path
        d="M188 292
           C 188 320, 184 340, 182 358
           L 218 358
           C 216 340, 212 320, 212 292 Z"
        fill={color}
      />

      {/* Roots — bold organic lines */}
      <g stroke={color} strokeLinecap="round" fill="none">
        {/* Left outer root */}
        <path d="M186 358 C 156 372, 118 376, 76 370" strokeWidth="10" />
        {/* Left inner root */}
        <path d="M190 360 C 174 378, 156 392, 132 400" strokeWidth="8" />
        {/* Right outer root */}
        <path d="M214 358 C 244 372, 282 376, 324 370" strokeWidth="10" />
        {/* Right inner root */}
        <path d="M210 360 C 226 378, 244 392, 268 400" strokeWidth="8" />
      </g>

      {/* Optional PATH flowing forward — curving symmetric ribbon */}
      {withPath && (
        <g stroke={actualPathColor} strokeLinecap="round" fill="none" opacity="0.9">
          {/* Left curving path */}
          <path
            d="M198 362
               C 196 385, 176 400, 148 405"
            strokeWidth="9"
          />
          {/* Right curving path */}
          <path
            d="M202 362
               C 204 385, 224 400, 252 405"
            strokeWidth="9"
          />
        </g>
      )}
    </svg>
  );
});

export default TreeIcon;
